import { Box } from "@mui/material";
import React from "react";
import { useTheme } from "@mui/material/styles";

import styled from "styled-components";
import legadoLogo from "../../../Assets/Images/legado.svg";
import { H1 } from "../../../Assets/Styles/GlobleStyles/TextStyles";

export default function HomeSection5() {
  const theme = useTheme();
  const ContentWrapper = styled.div`
    margin: 0 auto;
  `;
  const Button = styled.div`
    background-color: ${theme.palette.secondary.main};
    border-radius: 30px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
    color: white;
    padding: 15px 32px;
    text-align: center;
    text-shadow: 0px 4px 6px rgba(0, 0, 0, 0.15);
    display: inline-block;
    font-size: 24px;
    margin: 0 auto;
    cursor: pointer;
    transition: all 0.3s ease;

    :hover {
      transform: translateY(-3px);
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1),
        0px 20px 20px rgba(0, 0, 0, 0.15),
        inset 0px 0px 0px 0.5px rgba(0, 0, 0, 0.15);
    }

    *,
    & {
      transition: 1s cubic-bezier(0.075, 0.82, 0.165, 1);
    }

    @media (max-width: 1145px) {
      font-size: 20px;
      padding: 13px 30px;
    }
    
    @media (max-width: 1100px) {
      font-size: 18px;
      padding: 12px 28px;
    }
    
    @media (max-width: 715px) {
      font-size: 16px;
      padding: 12px 24px;
      border-radius: 25px;
    }
    
    @media (max-width: 480px) {
      font-size: 14px;
      padding: 10px 20px;
      border-radius: 20px;
    }
    
    @media (max-width: 375px) {
      font-size: 13px;
      padding: 9px 18px;
      border-radius: 18px;
    }
    
    @media (max-width: 320px) {
      font-size: 12px;
      padding: 8px 16px;
      border-radius: 16px;
    }
  `;
  const handleButtonClick = () => {
    window.open("https://hellolegado.com/", "_blank");
  };

  const Title = styled(H1)`
    font-size: 50px;
    line-height: 112.4%;
    text-align: center;
    color: ${theme.palette.text.main};
    text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
    margin: 0 auto;
    padding-bottom: 50px;

    @media (max-width: 1100px) {
      font-size: 45px;
      line-height: 110%;
    }
    
    @media (max-width: 975px) {
      font-size: 40px;
      line-height: 45px;
    }
    
    @media (max-width: 895px) {
      font-size: 38px;
      line-height: 42px;
    }
    
    @media (max-width: 855px) {
      letter-spacing: -0.01em;
      font-size: 35px;
      line-height: 40px;
    }
    
    @media (max-width: 715px) {
      font-size: 30px;
      line-height: 35px;
      padding-bottom: 30px;
    }
    
    @media (max-width: 480px) {
      font-size: 26px;
      line-height: 32px;
      padding-bottom: 25px;
    }
    
    @media (max-width: 375px) {
      font-size: 24px;
      line-height: 30px;
      padding-bottom: 20px;
    }
    
    @media (max-width: 320px) {
      font-size: 22px;
      line-height: 28px;
      padding-bottom: 15px;
    }
  `;

  const ContentSection = styled.div`
    padding-right: 74px;
    padding-left: 74px;
    margin-right: auto;
    margin-left: auto;
    max-width: 1904px;
    padding-top: 38px;
    padding-bottom: 38px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    border: 1px solid #000;
    background: ${theme.palette.legadoProduct.main};
    border-radius: 12px;
    color: #000;
    margin-bottom: 50px;
    
    @media (max-width: 1440px) {
      padding-right: 15px;
      padding-left: 15px;
    }
    
    @media (max-width: 1440px) {
      height: auto;
      padding-top: 15px;
      padding-bottom: 15px;
    }
    
    @media (max-width: 992px) {
      margin-top: 37px;
      padding: 20px 15px;
    }
    
    @media (max-width: 768px) {
      padding: 15px 10px;
      margin: 20px 10px 30px;
    }
    
    @media (max-width: 480px) {
      padding: 12px 8px;
      margin: 15px 5px 25px;
      border-radius: 8px;
    }
    
    @media (max-width: 375px) {
      padding: 10px 6px;
      margin: 10px 3px 20px;
      border-radius: 6px;
    }
  `;

  const ContentTitle = styled.div`
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    color: ${theme.palette.legadoProduct.text};
    font-size: 67px;
    font-style: normal;
    font-weight: 500;
    line-height: 73px;
    margin: 0%;
    padding: 0%;
    border-bottom: 1px solid;
    padding-bottom: 7px;
    max-width: 550px;
    
    @media (max-width: 992px) {
      line-height: 48px;
      max-width: 510px;
      font-size: 47px;
    }
    
    @media (max-width: 768px) {
      font-size: 36px;
      line-height: 42px;
      max-width: 100%;
    }
    
    @media (max-width: 480px) {
      font-size: 28px;
      line-height: 34px;
    }
    
    @media (max-width: 375px) {
      font-size: 24px;
      line-height: 30px;
    }
    
    @media (max-width: 320px) {
      font-size: 22px;
      line-height: 28px;
    }
  `;

  const BodySection = styled.div`
    color: ${theme.palette.legadoProduct.text};
    font-size: 25px;
    font-weight: 500;
    line-height: 35px;
    padding: 14px 0;
    
    @media (max-width: 768px) {
      font-size: 20px;
      line-height: 28px;
      padding: 10px 0;
    }
    
    @media (max-width: 480px) {
      font-size: 18px;
      line-height: 26px;
      padding: 8px 0;
    }
    
    @media (max-width: 375px) {
      font-size: 16px;
      line-height: 24px;
      padding: 6px 0;
    }
    
    @media (max-width: 320px) {
      font-size: 14px;
      line-height: 22px;
      padding: 5px 0;
    }
  `;

  const ImageWrapper = styled.div`
    position: absolute !important;
    width: auto;
    max-width: 100%;
    max-height: 82px;
    top: -42px;
    left: -50px;
    border-radius: 6px;
    padding: 10px;
    border-top: 1px solid #000;
    border-left: 1px solid #000;
    background: linear-gradient(to left, transparent 69%, #000 20%) bottom center / 100% 1px no-repeat, linear-gradient(to top, transparent 51%, #000 50%) right center / 1px 100% no-repeat, ${theme.palette.legadoProduct.main};
    
    @media (max-width: 1610px) {
      left: -1px;
      border-radius: 6px 6px 6px 0px;
      background: linear-gradient(to left, transparent 100%, ${theme.palette.legadoProduct.main} 0%) bottom center / 100% 1px no-repeat, linear-gradient(to top, transparent 50%, #000 21%) right center / 1px 100% no-repeat, ${theme.palette.legadoProduct.main};
    }
    
    @media (max-width: 992px) {
      top: -46px;
      background: linear-gradient(to left, transparent 100%, ${theme.palette.legadoProduct.main} 0%) bottom center / 100% 1px no-repeat, linear-gradient(to top, transparent 30%, #000 21%) right center / 1px 100% no-repeat, ${theme.palette.legadoProduct.main};
    }
    
    @media (max-width: 768px) {
      top: -40px;
      left: -1px;
      padding: 8px;
    }
    
    @media (max-width: 480px) {
      top: -34px;
      padding: 6px;
      max-height: 50px;
    }
    
    @media (max-width: 375px) {
      top: -31px;
      padding: 5px;
      max-height: 45px;
    }
    
    @media (max-width: 320px) {
      top: -27px;
      left: -1px;
      padding: 4px;
      max-height: 40px;
    }
  `;

  const Wrapper = styled.div`
    margin: 0 auto;
    padding-bottom: 0px;
    
    @media (max-width: 768px) {
      padding: 0 10px;
    }
    
    @media (max-width: 480px) {
      padding: 0 5px;
    }
  `;

  const BoxWrapper = styled.div`
    @media (max-width: 1290px) {
      gap: 0px 20px;
    }

    @media (max-width: 855px) {
      display: flex;
      flex-direction: column;
    }
    
    @media (max-width: 768px) {
      gap: 10px;
    }
    
    @media (max-width: 480px) {
      gap: 8px;
    }
  `;

  const ButtonWrapper = styled.div`
    display: flex;
    padding-top: 20px;
    
    @media (max-width: 715px) {
      padding-top: 15px;
      display: flex;
      justify-content: center;
    }
    
    @media (max-width: 480px) {
      padding-top: 12px;
    }
    
    @media (max-width: 375px) {
      padding-top: 10px;
    }
  `;

  const Image = styled.img`
    width: auto;
    max-width: 100%;
    max-height: 59px;
    
    @media (max-width: 992px) {
      max-height: 40px;
    }
    
    @media (max-width: 768px) {
      max-height: 35px;
    }
    
    @media (max-width: 480px) {
      max-height: 30px;
    }
    
    @media (max-width: 375px) {
      max-height: 28px;
    }
    
    @media (max-width: 320px) {
      max-height: 25px;
    }
  `;

  return (
    <Wrapper>
    <ContentWrapper>
        <Title>
          <b>
            <Box>
              <Box
                component="span"
                sx={{ color: `${theme.palette.primary.main}` }}
              >
                Featured
              </Box>{" "}
              Partner
            </Box>
          </b>
        </Title>
      </ContentWrapper>
      <ContentSection>
        <ContentTitle>Legado Protect</ContentTitle>
        <ImageWrapper>
        <Image src={legadoLogo} />
             </ImageWrapper>
             <BoxWrapper>
                  <BodySection>Legado simplifies legacy and estate planning by combining digital convenience with attorney- reviewed assurance for complete peace of mind. Free from confusing legal terms and uncomfortable attorney fact finders,</BodySection>
                  <BodySection>Legado created a simple technology platform with a 7-step process to create a comprehensive plan tailored to your needs. Loved ones including pets can benefit from our affordable estate planning solutions that will provide clarity and a celebration of life. Leaving a legacy is continual and ongoing,</BodySection>
                  <BodySection>Legado is here to help make that planning process easier for everyone.</BodySection>
                  <ButtonWrapper>
           <Button
           onClick={handleButtonClick}
            >
              <b>See More</b>
            </Button>
          </ButtonWrapper>
                </BoxWrapper>
      </ContentSection>
    </Wrapper>
  );
}
